import script from "./ReadyIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReadyIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./ReadyIndicator.vue?vue&type=style&index=0&id=fd7b41a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd7b41a6"]])

export default __exports__